import { useSelector } from 'react-redux';
import { getCurrentDecisionNodeContent } from 'extractFromState';
import { IconRoundedExclamationFilled } from 'components/common/SVGIcons';
import { Root, IconWrapper, Title, Text } from './Header.styles';

export default function Header() {
  const content = useSelector(getCurrentDecisionNodeContent);

  return (
    <Root>
      <IconWrapper>
        <IconRoundedExclamationFilled width={21} height={20} />
      </IconWrapper>
      <Title>{content.title}</Title>
      <Text>{content.subText}</Text>
    </Root>
  );
}
